import {
  getDoc, getDocs, setDoc, addDoc, updateDoc, deleteDoc,
} from "firebase/firestore";

// Add wrappers for the Firebase functions, which give better error messages

export class FirebaseUtils {
  constructor(userInfo) {
    this.userInfo = userInfo;
  }

  async getDoc(docRef, debugStr) {
    try {
      return await getDoc(docRef);
    } catch (err) {
      throw new Error(this._makeErrorString('getDoc', debugStr, err.message));
    }
  }

  async getDocs(q, debugStr) {
    try {
      return await getDocs(q);
    } catch (err) {
      throw new Error(this._makeErrorString('getDocs', debugStr, err.message));
    }
  }

  async setDoc(docRef, data, debugStr) {
    try {
      return await setDoc(docRef, data);
    } catch (err) {
      throw new Error(this._makeErrorString('setDoc', debugStr, err.message));
    }
  }

  async addDoc(collectionRef, data, debugStr) {
    try {
      return await addDoc(collectionRef, data);
    } catch (err) {
      throw new Error(this._makeErrorString('addDoc', debugStr, err.message));
    }
  }

  async updateDoc(docRef, data, debugStr) {
    try {
      return await updateDoc(docRef, data);
    } catch (err) {
      throw new Error(this._makeErrorString('updateDoc', debugStr, err.message));
    }
  }

  async deleteDoc(docRef, debugStr) {
    try {
      return await deleteDoc(docRef);
    } catch (err) {
      throw new Error(this._makeErrorString('deleteDoc', debugStr, err.message));
    }
  }

  _makeErrorString(method, debugStr, errMsg) {
    return `Error on ${method} for ${debugStr} ` +
      `(email=${this.userInfo.email}, verified=${this.userInfo.emailVerified}): ${errMsg}`;
  }
};